
export default function ResourceHero() {
  return (
    <section className="relative pt-32 pb-20 px-6 bg-gradient-to-br from-[#e10708] via-[#c00607] to-[#a00506] overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
      
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-72 h-72 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-5xl mx-auto text-center">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-white/20 backdrop-blur-sm rounded-full mb-8">
          <i className="ri-book-open-line text-4xl text-white"></i>
        </div>
        
        <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
          Healthcare Practice Startup &amp; Growth Resource Guide
        </h1>
        
        <p className="text-2xl text-red-50 mb-8 font-medium">
          Your Trusted Technology &amp; Operations Partner
        </p>
        
        <p className="text-lg text-white/90 max-w-3xl mx-auto leading-relaxed">
          Starting or expanding a healthcare practice is complex. Technology, compliance, operations, and vendor decisions can either set you up for long-term success—or create costly problems down the road.
        </p>
      </div>
    </section>
  );
}